export const admin = {
  redirect: 'auth-success',
  auth: 'auth-error',
  reset: 'reset-password',
  code: 'verification-code',
  change: 'password-change',
  admins: 'all-admins-received',
  details: 'user-details-received',
  create: 'new-admin-created',
  update: 'admin-details-updated'
}
